var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"header"},[_c('v-row',{attrs:{"no-gutters":"","justify-center":"","align-center":""}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/logos/kasasaLogo.svg","alt":"Kasasa Logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }